import { SxProps } from '@mui/material';
import { DataGridPremiumProps } from '@mui/x-data-grid-premium';
import { useMemo } from 'react';

type PropsType = {
  rowsCount: number | undefined;
  settings: {
    scrollRowCount: number;
    rowHeight: number;
    headerRowHeight: number;
  };
};
type UseDataGridAutoHeightToScrollOutput = {
  containerProps: {
    sx?: SxProps;
  };
  dataGridProps: Pick<DataGridPremiumProps, 'autoHeight'>;
};

export const useDataGridAutoHeightToScroll = (
  props: PropsType,
): UseDataGridAutoHeightToScrollOutput => {
  const { rowsCount, settings } = props;

  const { isVerticalScrollEnabled, dataGridContainerSx } = useMemo(() => {
    const { scrollRowCount, rowHeight, headerRowHeight } = settings;

    const isVerticalScrollEnabled = (rowsCount ?? 0) > scrollRowCount;
    const dataGridHeight = scrollRowCount * rowHeight + headerRowHeight;

    return {
      isVerticalScrollEnabled,
      dataGridContainerSx: isVerticalScrollEnabled
        ? { height: `${dataGridHeight}px` }
        : undefined,
    };
  }, [rowsCount, settings]);

  return {
    containerProps: {
      sx: dataGridContainerSx,
    },
    dataGridProps: {
      autoHeight: !isVerticalScrollEnabled,
    },
  };
};
